import React, { useEffect, useState, useRef } from "react";
import { Col } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { fetchAnswerForSeek, invalidateSeekSession } from "src/redux/actions/seek";
import { fetchSeekLimit } from 'src/legacy/redux/actions/search';
import SeekSearch from "src/pages/seek/components/seekSearch";
import Text from "src/components/text";
import { SeekLandingPageProps, SeekSession, Chat } from "src/types/seekLandingpage";
import _ from "lodash";
import cx from "classnames";
import styles from "./style.module.scss";
import { useLocation } from "react-router";
import Truncate from "src/components/truncate";
import Tooltip from "src/components/tooltip";
import { useSeekAdoption } from "src/redux/actions/adoption/seek";
export default function SeekLandingPage(props: SeekLandingPageProps) {
  const dispatch = useDispatch();
  const { trackSeekPromptClicked } = useSeekAdoption();

  const previousQueryRef = useRef<string>("");
  const streamName = _.get(props, "stream.name", "");  
  const account = useSelector((state: any) => _.get(state, 'accounts.item'));
  const isSeekEnabled = Boolean(_.get(account, "seekEnabled", false));
  const user = useSelector((state: any) => _.get(state, 'users.me', {}));
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get('query');
  const searchFields = queryParams.get('fields');
  const seekSession = useSelector((state: any) => _.get(state, 'seek.session.item')) as SeekSession | undefined;
  const isSeekLoading = Boolean(useSelector((state: any) => _.get(state, 'seek.session.loading')));
  const seekErrors = useSelector((state: any) => _.get(state, "legacyRootReducer.search.seek.error.errors")) as Array<{ code: number }> | undefined;
  const isSeekLimitExceeded = Boolean(_.find(seekErrors, { code: 20003 }));
  const seekSuggestedQuestions = (useSelector((state: any) => _.get(state, 'legacyRootReducer.search.seek.suggestions.items', [])) as string[]) || [];
  
  const [seekRedirect, setSeekRedirect] = useState<boolean>(false);
  const [query, setQuery] = useState<string>("");
  const [showSeekSearch, setShowSeekSearch] = useState<boolean>(false);
  const [selectedQuestion, setSelectedQuestion] = useState<string | undefined>(undefined);
  const [seekAnswerExits, setSeekAnswerExits] = useState(false);
  const chats = _.get(seekSession, "chats", []) as any;
  const compactView = _.size(searchFields) > 0 || _.size(searchQuery) > 0;

  useEffect(() => {
    dispatch(fetchSeekLimit() as any);
  }, []);
  useEffect(() => {
   if(!compactView && _.size(searchQuery) === 0 && _.size(searchFields) === 0){ 
    handleClearQuery();
  }
  },[compactView])
  useEffect(() => {
    if(_.size(chats) > 0){
      const seekResponse = chats[0];
       if(!seekResponse?.loading && _.size(seekResponse?.answer) > 0 && seekResponse?.id){
           setSeekAnswerExits(true);
       }
    } else {
       setSeekAnswerExits(false);
    }
  }, [isSeekLoading ,chats])
  useEffect(() => {
    const query = _.get(props, "query", "") as string;
    if (_.size(query) > 0) {
      setQuery(query);
    }
  }, [_.get(props, "query")]);
 
  const handleSearchQuery = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e) {
      e.preventDefault();
    }
    if (!isSeekEnabled) {
      props._handleSearch();
      return;
    }
    if (!isSeekLoading) {
      if (_.size(query) === 0) {
        dispatch(invalidateSeekSession() as any);
      }
      if (_.size(query) > 0 && !isSeekLimitExceeded) {
        previousQueryRef.current = query;
        dispatch(
          fetchAnswerForSeek({
            id: null,
            question: query,
            session: '',
            request: {
              includeActions: false,
            }
          }) as any
        );
      }
      props._handleSearch();
    }
  };
  const handleClearQuery = () => {
    if (isSeekLoading || props.isFetching()) return
    setQuery("");
    previousQueryRef.current = "";  //For removing the stored query
    props.clearValue();
  };
  const handlePromptsClick = (question: string) => {
    setSelectedQuestion(question);
    setShowSeekSearch(true);
    trackSeekPromptClicked({ prompt: question });
  };
  const handleQueryChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if(_.size(e.target.value.trim()) > 0) { // to avoid spaces & empty queries
         props._onQueryChange(e);
         setQuery(e.target.value.trim());
    } else {
      handleClearQuery();
    }
  };
  return (
  <>
    <div className={cx(styles.centeredSearchWrapper, {
      [styles.hasResults]: compactView,
      [styles.customFieldsAvailable]: props.isCustomFieldsAvailable,
    })}>
      <div className={styles.searchBoxContainer}>
          {!compactView && (
          <>
            <h3 className={styles.Name}>Hi {_.get(user, "firstName")}</h3>
            <h3 className={styles.subTitle}>how can I help you today?</h3>
          </>
        )}
        <div className={cx(styles.column, styles.searchBar, { [styles.searchBarCompact]: compactView })}>
          <form onSubmit={handleSearchQuery}>
            <div className={styles.inputContainer}>
              <div className={cx(styles.noPadding, { [styles.inputCompact]: compactView })}>
                <div className={styles.search}>
                    <label className={cx({ [styles.disabled]: isSeekLoading || props.isFetching() })}>
                      {props.isFromStream && (
                        <span className={styles.tagName}>
                          {streamName && (
                            <Text
                              className={styles.streamTag}
                              text={`in: ${streamName}`}
                              lines={1}
                            />
                          )}
                        </span>
                      )}
                      {props.isFromHub && (
                        <span className={cx(styles.tagName, styles.block)}>
                          {"in:hub"}
                        </span>
                      )}
                    
                    <textarea
                        className={cx(styles.field,)}
                        name="search"
                        style={{ resize: 'none' }}
                        value={props.query}
                        placeholder={"Ask anything..."}
                        onChange={handleQueryChange}
                        disabled={isSeekLoading || props.isFetching()}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            handleSearchQuery();
                          }
                        }}
                      />
                      {_.size(props.query) > 0 && compactView &&(
                        <div className={styles.inputActions}>
                          <i
                            onClick={handleClearQuery}
                            className={cx("paperflite-close", styles.clearIcon)}
                          />
                          <span className={styles.divider}></span>
                        </div>
                      )}
                      <button
                        type="button"
                        disabled={isSeekLoading || props.isFetching()}
                        className={cx(styles.searchButton, {
                          [styles.searchButtonActive]: _.size(props.query) > 0
                        })}
                        onClick={(e) => {
                          e.preventDefault();
                          if (isSeekLoading || props.isFetching() || _.size(props.query) === 0) {
                            return;
                          }
                          handleSearchQuery();
                        }}
                      >
                        <i className="paperflite-right-arrow" />
                      </button>
                    </label>
                  </div>
              </div>
            </div>
          </form>
        </div>
        {isSeekEnabled && !compactView && !props.isFetching() && _.size(seekSuggestedQuestions) > 0 && (
          <div className={styles.promptsContainer}>
            <div className={styles.prompts}>
              {seekSuggestedQuestions.map((question, index) => (
                      <p key={index} onClick={() => handlePromptsClick(question)}>
                          <Truncate lines={1} width={704}>{question}</Truncate>
                      </p>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
    {showSeekSearch && (
      <SeekSearch
        question={selectedQuestion ?? ""}
        onClose={() => {
          setShowSeekSearch(false);
          setSeekRedirect(false);
          setSelectedQuestion(undefined);
          const previousQuery = previousQueryRef.current;
          if (_.size(previousQuery) > 0) {
            setQuery(previousQuery);
            props._onQueryChange({ target: { value: previousQuery } } as React.ChangeEvent<HTMLTextAreaElement>);
          }
        }}
        isLimitExceeded={isSeekLimitExceeded}
      />
    )}
  </>
);
}